import actionTypes from "./actionTypes";

const actions = {
  deletePayroll: (payroll, options = {}) => ({
    ...options,
    type: actionTypes.DELETE_PAYROLL,
    payload: {
      payroll,
    },
  }),
  deletePayrollLine: (payroll, payrollLine, options = {}) => ({
    ...options,
    type: actionTypes.DELETE_PAYROLL_LINE,
    payload: {
      payroll,
      payrollLine,
    },
  }),
  deletePayrollLines: (payroll, data, options = {}) => ({
    ...options,
    type: actionTypes.DELETE_PAYROLL_LINES,
    payload: {
      payroll,
      data: {
        data,
      },
    },
  }),
  getConfig: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_CONFIG,
    payload: {
      params,
    },
  }),
  getConfigAlerts: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_CONFIG_ALERTS,
    payload: {
      params,
    },
  }),
  getConfigHolidays: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_CONFIG_HOLIDAYS,
    payload: {
      params,
    },
  }),
  getEmployee: (employee, params, options = {}) => ({
    ...options,
    type: actionTypes.GET_EMPLOYEE,
    payload: {
      employee,
      params,
    },
  }),
  getLedgerPdf: (ledger, params, options = {}) => ({
    ...options,
    type: actionTypes.GET_LEDGER_PDF,
    payload: {
      ledger,
      params,
    },
  }),
  getLedgers: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_LEDGERS,
    payload: {
      params,
    },
  }),
  getLedgersTotal: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_LEDGERS_TOTAL,
    payload: {
      params,
    },
  }),
  getLinePdf: (line, params, options = {}) => ({
    ...options,
    type: actionTypes.GET_LINE_PDF,
    payload: {
      line,
      params,
    },
  }),
  getLinesAvailable: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_LINES_AVAILABLE,
    payload: {
      params,
    },
  }),
  getLinesTransient: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_LINES_TRANSIENT,
    payload: {
      params,
    },
  }),
  getLinesTransientTotal: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_LINES_TRANSIENT_TOTAL,
    payload: {
      params,
    },
  }),
  getMeClients: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_CLIENTS,
    payload: {
      params,
    },
  }),
  getMeConfig: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_CONFIG,
    payload: {
      params,
    },
  }),
  getMeConfigAlerts: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_CONFIG_ALERTS,
    payload: {
      params,
    },
  }),
  getMeConfigHolidays: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_CONFIG_HOLIDAYS,
    payload: {
      params,
    },
  }),
  getMeInfo: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_INFO,
    payload: {
      params,
    },
  }),
  getMeJob: (job, params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_JOB,
    payload: {
      job,
      params,
    },
  }),
  getMeJobs: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_JOBS,
    payload: {
      params,
    },
  }),
  getMeLedger: (ledger, params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_LEDGER,
    payload: {
      ledger,
      params,
    },
  }),
  getMeLedgers: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_LEDGERS,
    payload: {
      params,
    },
  }),
  getMeLedgersTotal: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_LEDGERS_TOTAL,
    payload: {
      params,
    },
  }),
  getMeLine: (line, params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_LINE,
    payload: {
      line,
      params,
    },
  }),
  getMeLines: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_LINES,
    payload: {
      params,
    },
  }),
  getMeLinesTotal: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_ME_LINES_TOTAL,
    payload: {
      params,
    },
  }),
  getPayroll: (payroll, params, options = {}) => ({
    ...options,
    type: actionTypes.GET_PAYROLL,
    payload: {
      payroll,
      params,
    },
  }),
  getPayrollExport: (payroll, params, options = {}) => ({
    ...options,
    type: actionTypes.GET_PAYROLL_EXPORT,
    payload: {
      payroll,
      params,
    },
  }),
  getPayrolls: (params, options = {}) => ({
    ...options,
    type: actionTypes.GET_PAYROLLS,
    payload: {
      params,
    },
  }),
  patchLineSkip: (line, options = {}) => ({
    ...options,
    type: actionTypes.PATCH_LINE_SKIP,
    payload: {
      line,
    },
  }),
  patchPayrollAuthorise: (payroll, options = {}) => ({
    ...options,
    type: actionTypes.PATCH_PAYROLL_AUTHORISE,
    payload: {
      data: {
        really: true,
      },
      payroll,
    },
  }),
  patchPayrollLine: (payroll, payrollLine, data, options = {}) => ({
    ...options,
    type: actionTypes.PATCH_PAYROLL_LINE,
    payload: {
      data,
      payroll,
      payrollLine,
    },
  }),
  patchPayrollLineRevise: (payroll, payrollLine, options = {}) => ({
    ...options,
    type: actionTypes.PATCH_PAYROLL_LINE_REVISE,
    payload: {
      data: {
        really: true,
      },
      payroll,
      payrollLine,
    },
  }),
  patchPayrollUnlock: (payroll, options = {}) => ({
    ...options,
    type: actionTypes.PATCH_PAYROLL_UNLOCK,
    payload: {
      data: {
        really: true,
      },
      payroll,
    },
  }),
  postConvert: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_CONVERT,
    payload: {
      data,
    },
  }),
  postExportInvoices: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_EXPORT_INVOICES,
    payload: {
      data: cleanData(data),
    },
  }),
  postImportLedgers: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_IMPORT_LEDGERS,
    payload: {
      data,
    },
  }),
  postLedgers: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_LEDGERS,
    payload: {
      data,
    },
  }),
  postLinesProcess: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_LINES_PROCESS,
    payload: {
      data,
    },
  }),
  postMeRequestCurrency: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_ME_REQUEST_CURRENCY,
    payload: {
      data,
    },
  }),
  postMeRequestInvoice: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_ME_REQUEST_INVOICE,
    payload: {
      data,
    },
  }),
  postPayrollLines: (payroll, data, options = {}) => ({
    ...options,
    type: actionTypes.POST_PAYROLL_LINES,
    payload: {
      data,
      payroll,
    },
  }),
  postPayrollRevise: (payroll, options = {}) => ({
    ...options,
    type: actionTypes.POST_PAYROLL_REVISE,
    payload: {
      data: {
        really: true,
      },
      payroll,
    },
  }),
  postPayrolls: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_PAYROLLS,
    payload: {
      data,
    },
  }),
};

function cleanData(data) {
  if (data) {
    const cleaned = {};
    Object.keys(data).forEach((key) => {
      if (data[key] !== null) {
        cleaned[key] = data[key];
      }
    });
    return cleaned;
  }
  return data;
}

export default actions;
